// import React from "react";
// import Button from "@material-ui/core/Button";
// import ButtonGroup from "@material-ui/core/ButtonGroup";

// export default function MessageActions(props) {
//   return (
//     <>
//       <ButtonGroup
//         variant="contained"
//         color="primary"
//         aria-label="contained primary button group"
//       >
//         {props.actions.map((action, i) => {
//           return (
//             <Button key={i} size="small" onClick={action.onClick}>
//               {action.value}
//             </Button>
//           );
//         })}
//       </ButtonGroup>
//     </>
//   );
// }
import React from "react";

export default function MessageActions(props) {
  const styles = `
    .yes_button {
      border-radius: 20px;
      border: none;
      background-color: green;
      color: white;
      height: 25px;
      width: 50px;
      cursor: pointer;
    }
    .yes_button:hover {
      background-color: darkgreen;
    }
    .no_button {
      border-radius: 20px;
      border: none;
      background-color: red;
      color: white;
      height: 25px;
      width: 50px;
      margin-left: 15px;
      cursor: pointer;
    }
    .no_button:hover {
      background-color: darkred;
    }
  `;

  return (
    <>
      <div
        style={{
          display: "flex",
          marginTop: "41px",
          marginLeft: "-1%",
          justifyContent: "center",
        }}
      >
        <button
          className="yes_button"
          onClick={props?.actions?.[0]?.onClick}
        >
          YES
        </button>
        <button
          className="no_button"
          onClick={props?.actions?.[1]?.onClick}
        >
          NO
        </button>
      </div>
      <style>{styles}</style>
    </>
  );
}
